import React, { useState, useEffect } from "react";
import Button from "../../../Button/Button";
import TableFixedPage from "../../../TableFixedPage/TableFixedPage";
import SupplierTable from "../../../Tables/UserPart/UserList/SupplierTable/SupplierTable";
import { Modal } from "react-bootstrap";
import {
  deactivateUserPostApi,
  getSupplierInfoApi,
  getSupplierListApi,
  getWalletInfoApi,
} from "../../../../Api/PanelAdminServices";
import SupplierInfo from "../../../Modal/Information/SupplierInfo/SupplierInfo";
import { errorToast, succToast } from "../../../../Utils/Toast/Toast";
import { useHistory } from "react-router-dom";
import ShabaModal from "../../../Modal/Information/ShabaModal/ShabaModal";
import { separate } from "../../../../Utils/SeprateNumber/SeprateThreeNumber";
import WalletInfo from "../../../Modal/Information/WalletInfo/WalletInfo";

const SupplierContainer = () => {
  const [rawInfo, setRawInfo] = useState();
  const [supplierList, setSupplierList] = useState([]);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [scoreVisible, setScoreVisible] = useState(false);
  const [userInfo, setUserInfo] = useState(false);
  const [userId, setUserId] = useState();
  const [wallet, setWallet] = useState();
  const [supplierDetail, setSupplierDetail] = useState([]);
  const [shabaAvailable, setShabaAvailable] = useState(false);
  const [disable, setDisable] = useState(false);

  let history = useHistory();

  useEffect(() => {
    getSupplierList();
  }, []);

  const getSupplierList = async () => {
    getSupplierListApi((succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setSupplierList(res.suppliers);
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
      }
    })
  };
  ////////buttons in table//////////
  const showAddress = async (id, info) => {
    getSupplierInfoApi(info.key, (succ, res) => {
      if (succ) {
        if (res.status === 0) {
          errorToast(res.message);
        } else {
          setSupplierDetail(res.info);
          /////Edit///////
          if (id === 2) {
            setEditVisible(true);
            history.push(`/editsupplierinfo/${info.key}`, res.info);
          }
        }
      } else {
        errorToast("خطایی در سرور رخ داده است");
      }
    });
    setRawInfo(info);
    setUserId(info.key);
    ////wallet/////
    if (id === 1) {
      getWalletInfoApi(info.id, (succ, res) => {
        if (succ) {
          if (res.status === 0) {
            errorToast("مشکلی پیش آمده");
          } else {
            res.transactions.sort((a,b)=>{
              if(a.id>b.id){
                return -1
              }else return 1
            })
            setWallet(res.transactions);
            setScoreVisible(true);
          }
        } else {
          errorToast("خطایی در سرور رخ داده است");
        }
      });
    }
    //////Delete///////
    if (id === 3) {
      setDeleteVisible(true);
    }
    //////user info//////
    if (id === 4) {
      setUserInfo(true);
    }
    ///////////shaba part ///////////
    if (id === 5) {
      setShabaAvailable(true);
    }
  };
  const deactiveCustomer = () => {
    setDisable(true);
    let info = {
      id: userId,
      status: rawInfo.status === "0" ? "1" : "0",
      type: "supplier",
    };
    deactivateUserPostApi(info, (res) => {
      if (res.status === 1) {
        succToast("با موفقیت انجام شد");
        setDisable(false);
        setDeleteVisible(false);
      } else {
        errorToast("مشکلی پیش آمد");
        setDisable(false);
        setDeleteVisible(false);
      }
    });
    getSupplierList();
  };
  const handleOkAddress = () => {
    setDeleteVisible(false);
    setEditVisible(false);
    setScoreVisible(false);
    setShabaAvailable(false);
    setUserInfo(false);
  };
  const data =
    supplierList &&
    supplierList.map((item) => {
      return {
        key: item.id,
        id: item.id,
        fName: item.first_name + " " + item.last_name,
        marketName: item.name,
        phone: item.phone,
        signUpDate: item.register_date,
        type: item.type === "food" ? "رستوران" : " فروشگاه",
        typeUrl: item.type,
        countProduct: item.total_product,
        totalOrder: item.total_order,
        status: item.status,
        money: separate(parseInt(item.deposited) + parseInt(item.withdrawaled)),
        name:item.name,
        city:item.city_name,
      };
    });
  const TitleStyle = {
    width: "100%",
    color: "#c20c64",
    textAlign: "center",
    fontSize: "1.1rem",
  };
  return (
    <div>
      <Modal show={deleteVisible} onHide={handleOkAddress}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>
            آیا از غیرفعال کردن کاربر موردنظر مطمئن هستید؟
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-around",
            }}
          >
            <Button
              ClassBtn={"rejectBtn"}
              Value={"خیر"}
              ClickHandler={handleOkAddress}
            />
            <Button
              ClassBtn={"confirmBtn"}
              Value={"بله"}
              ClickHandler={deactiveCustomer}
              disabledprops={disable}
            />
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={userInfo} onHide={handleOkAddress}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>اطلاعات تامین کننده</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        {supplierDetail&&<SupplierInfo Info={supplierDetail} handleOk={handleOkAddress} />}
        </Modal.Body>
      </Modal>

      <Modal show={shabaAvailable} onHide={handleOkAddress}>
        <Modal.Body>
          <ShabaModal type={"supplier"} data={supplierDetail} />
        </Modal.Body>
      </Modal>

      <Modal show={scoreVisible} onHide={handleOkAddress}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>تراکنشات</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <WalletInfo data={wallet} />
        </Modal.Body>
      </Modal>

      <TableFixedPage title="لیست تامین کنندگان" />
      <SupplierTable showAddress={showAddress} data={data} />
    </div>
  );
};

export default SupplierContainer;
